import { ApiHandler, ApiHandlerDiscreteParameter, HasOnSuccess, replaceInChain } from "@insite/client-framework/HandlerCreator";
import { submitContactUsForm, SubmitContactUsFormApiParameter } from "@insite/client-framework/Services/EmailService";
import { chain, SendDataToApi } from "@insite/client-framework/Store/Components/ContactUsForm/Handlers/SubmitContactForm";
import { niscoSubmitContactUsForm } from "@tCentro/Services/EmailServiceExtension";

type SubmitContactFormParameter = {
    emailRecipients: string;
} & HasOnSuccess;

type HandlerType = ApiHandlerDiscreteParameter<SubmitContactFormParameter, SubmitContactUsFormApiParameter>;

export const CustomSendDataToApi: HandlerType = async props => {
    const state = props.getState();
    const siteName = state.context.website.name;
    (siteName === "Nisco") ? await niscoSubmitContactUsForm(props.apiParameter)  : await submitContactUsForm(props.apiParameter);
};

replaceInChain(chain, SendDataToApi, CustomSendDataToApi);